import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { MojoPrivilegesService } from 'mojo-privileges';
import { Observable, of } from 'rxjs';
import { first } from 'rxjs/operators';

import { isModalConfirmed, ModalShow } from '@shared/modal';
import { JobEditPageComponent } from '@shared/job-form/containers/page/job-edit-page.component';

@Injectable()
export class JobFormGuard {
  constructor(private privilegesService: MojoPrivilegesService, private store: Store<{}>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const privilege = route.data.privilege;
    return this.privilegesService.hasPrivilege(privilege);
  }

  canDeactivate(component: JobEditPageComponent): Observable<boolean> {
    if (component.canDeactivate()) {
      return of(true);
    }
    this.store.dispatch(
      new ModalShow({
        title: 'Are you sure you want to leave this page?',
        message: 'All unsaved changes will be lost.',
      }),
    );
    return this.store.select(isModalConfirmed).pipe(first((confirmed) => !!confirmed));
  }
}
